export const SET_TYPES = 'SET_TYPES';
export const SET_TYPE = 'SET_TYPE';
export const GET_TYPES = 'GET_TYPES';
export const GET_TYPE = 'GET_TYPE';
export const CREATE_TYPE = 'CREATE_TYPE';
export const EDIT_TYPE = 'EDIT_TYPE';
export const IS_FETCHING = 'IS_FETCHING';
export const ERROR = 'ERROR';
export const CLEAN = 'CLEAN';
export const ALERT = 'ALERT';
export const IS_SENDING = 'IS_SENDING';